// contentFeedActions.js — action type constants + creators for Content Feed

export const GET_CONTENT_FEED_REQUEST = "GET_CONTENT_FEED_REQUEST";
export const GET_CONTENT_FEED_SUCCESS = "GET_CONTENT_FEED_SUCCESS";
export const GET_CONTENT_FEED_FAILURE = "GET_CONTENT_FEED_FAILURE";

export const REFRESH_CONTENT_FEED_REQUEST = "REFRESH_CONTENT_FEED_REQUEST";
export const REFRESH_CONTENT_FEED_SUCCESS = "REFRESH_CONTENT_FEED_SUCCESS";
export const REFRESH_CONTENT_FEED_FAILURE = "REFRESH_CONTENT_FEED_FAILURE";

export const SEARCH_CONTENT_FEED_REQUEST = "SEARCH_CONTENT_FEED_REQUEST";
export const SEARCH_CONTENT_FEED_SUCCESS = "SEARCH_CONTENT_FEED_SUCCESS";
export const SEARCH_CONTENT_FEED_FAILURE = "SEARCH_CONTENT_FEED_FAILURE";

export const CLEAR_CONTENT_FEED_SEARCH = "CLEAR_CONTENT_FEED_SEARCH";

export const getContentFeedRequest = (payload) => ({ type: GET_CONTENT_FEED_REQUEST, payload });
export const getContentFeedSuccess = (data) => ({ type: GET_CONTENT_FEED_SUCCESS, payload: data });
export const getContentFeedFailure = (error) => ({ type: GET_CONTENT_FEED_FAILURE, payload: error });

export const refreshContentFeedRequest = (payload) => ({ type: REFRESH_CONTENT_FEED_REQUEST, payload });
export const refreshContentFeedSuccess = (data) => ({ type: REFRESH_CONTENT_FEED_SUCCESS, payload: data });
export const refreshContentFeedFailure = (error) => ({ type: REFRESH_CONTENT_FEED_FAILURE, payload: error });

export const searchContentFeedRequest = (payload) => ({ type: SEARCH_CONTENT_FEED_REQUEST, payload });
export const searchContentFeedSuccess = (data) => ({ type: SEARCH_CONTENT_FEED_SUCCESS, payload: data });
export const searchContentFeedFailure = (error) => ({ type: SEARCH_CONTENT_FEED_FAILURE, payload: error });

export const clearContentFeedSearch = () => ({ type: CLEAR_CONTENT_FEED_SEARCH });

export const CLEAR_CONTENT_FEED_REFRESH = "CLEAR_CONTENT_FEED_REFRESH";
export const clearContentFeedRefresh = () => ({ type: CLEAR_CONTENT_FEED_REFRESH });
